import { styled, Typography } from '@mui/material';
import { type FC } from 'react';
import { useToggle } from '../../../../../../../../hooks/use-toggle';
import { ControlledTextInput } from '../../../../components/ControlledTextInput';
import { ConfigurationSection } from '../../../../containers/ConfigurationSection';
import type {
  MorningConfigurationControl,
  MorningConfigurationFormValues,
} from '../../MorningConfigurationFormSchema';

type Props = {
  defaultValues: MorningConfigurationFormValues;
  control: MorningConfigurationControl;
}

export const TokenConfigurationSection: FC<Props> = ({ control, defaultValues }) => {
  const [disabled, toggleDisabled] = useToggle(true);

  return (
    <ConfigurationSection title="Morning Credentials" iconName="Key">
      <TextInputContainer>
        <TextInputHeaderContainer>
          <Typography
            sx={{
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '12px',
              opacity: disabled ? 0.6 : 1,
            }}
          >
            API Token
          </Typography>
          <Typography
            sx={{
              color: '#3A78F8',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: '12px',
              cursor: 'pointer',
            }}
            onClick={() => toggleDisabled()}
          >
            Modify
          </Typography>
        </TextInputHeaderContainer>
        <ControlledTextInput
          name="apiKey"
          control={control}
          disabled={disabled}
          placeholder="Enter API Token here..."
          defaultValue={defaultValues.apiKey || ''}
        />
        <Typography
          sx={{
            fontSize: '12px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '12px',
            opacity: disabled ? 0.6 : 1,
            marginTop: '16px',
          }}
        >
          Secret ID
        </Typography>
        <ControlledTextInput
          name="secretId"
          control={control}
          disabled={disabled}
          placeholder="Enter Secret ID here..."
          defaultValue={defaultValues.secretId || ''}
        />
      </TextInputContainer>
    </ConfigurationSection>
  );
};

const TextInputContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

const TextInputHeaderContainer = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
});